import { render, staticRenderFns } from "./firstCampApproval.vue?vue&type=template&id=194914ed&scoped=true"
import script from "./firstCampApproval.vue?vue&type=script&lang=js"
export * from "./firstCampApproval.vue?vue&type=script&lang=js"
import style0 from "./firstCampApproval.vue?vue&type=style&index=0&id=194914ed&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194914ed",
  null
  
)

export default component.exports